<template>
  <a v-if="isExternal()" :href="href" :target='target'>
    <slot/>
  </a>
  <router-link v-else :target='target' :to="href">
    <slot/>
  </router-link>
</template>

<script>
export default {
  name: "m-a",
  props: {
    href: {},
    target: {
      default: '_self'
    }
  },
  methods: {
    gotoTop() {
      window.scroll(0, 0);
    },
    isExternal() {
      return typeof this.href === "string" && this.href.startsWith("http");
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>

